import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import SsoServices from "../../../../services/SsoServices";
import { PAYMENT_STATUS } from "../../../../constants/api-constants";
import "./PaymentProcessing.css";
/*istanbul ignore next */
const PaymentProcessing = () => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    let intervalId = null;

    const checkPaymentStatus = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const sessionId = params.get("session_id");
        if (!sessionId) {
          history.push("/payment-success");
          return;
        }

        const response = await SsoServices.ssoGet(
          `${PAYMENT_STATUS}?sessionId=${sessionId}`,
        );

        if (response?.responseStatus?.isSuccess) {
          if (intervalId) {
            clearInterval(intervalId);
          }
          const redirectUrl = `/payment-success?session_id=${sessionId}`;
          history.push(redirectUrl);
        }
      } catch (error) {
        console.error("Error checking payment status:", error);
      }
    };
    checkPaymentStatus();
    intervalId = setInterval(() => {
      checkPaymentStatus();
    }, 5000);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [history, location.search]);

  return (
    <div className="payment-processing-container">
      <div className="payment-processing-content">
        <CircularProgress
          size={80}
          thickness={4}
          style={{ color: "#00d9ff" }}
        />
        <h2>Processing Your Payment</h2>
        <p>Please wait while we confirm your payment...</p>
        <p className="processing-note">
          Do not close this window or press the back button
        </p>
      </div>
    </div>
  );
};

export default PaymentProcessing;
